import { POLL_TYPE } from 'wix-rich-content-common';
var isSSR = function () { return typeof window === 'undefined'; };
var fetchMembers = function (instance) {
    return fetch("/api/wix-sm/v1/profiles?limit=100", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: instance,
        },
    })
        .then(function (res) {
        if (res.ok)
            return res.json();
        else
            throw res.statusText;
    })
        .then(function (json) { return json.profiles; });
};
var normalizeMembers = function (rawMembers) { var _a; return (_a = rawMembers === null || rawMembers === void 0 ? void 0 : rawMembers.map) === null || _a === void 0 ? void 0 : _a.call(rawMembers, function (member) {
    return {
        siteMemberId: member.id,
        imageUrl: member.imageUrl,
        name: {
            nick: member.nickname,
        },
    };
}); };
var members;
export default function pollsStrategy(instance) {
    var _a;
    if (!instance)
        return {};
    !isSSR() && // TODO: trigger getSiteMembers & fetch inside polls and wait for response
        fetchMembers(instance)
            .then(normalizeMembers)
            .then(function (fetchedMembers) { return (members = fetchedMembers); });
    return {
        config: (_a = {},
            _a[POLL_TYPE] = {
                siteToken: instance,
                getSiteMembers: function () { return members; },
            },
            _a),
    };
}
//# sourceMappingURL=pollsStrategy.js.map